// Styles
import FairValueChartsViewContainer from "./FairValueChartsView.styles";
import PowerBIDashboard from "../../../../components/Common/PowerBIDashboard";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useBQMQ } from "context/BQMQ.context";

type Props = {};

export default function FairValueChartsView({}: Props) {
    const location = useLocation();
    const { companies } = useBQMQ();

    const companyId = useMemo(() => {
        return new URLSearchParams(location.search).get("company_id");
    }, [location.search]);

    const company = useMemo(() => {
        if (!companyId) return null;
        return (
            companies.find(
                (c: BQMQDropdownCompany) => String(c.value) === companyId
            ) ?? null
        );
    }, [companyId, companies]);

    const filterString = company
        ? `dim_full_snapshot_companies_list/bbg_company_name eq '${company.label}'`
        : undefined;

    return (
        <FairValueChartsViewContainer>
            <div className="iframeContainer">
                <PowerBIDashboard
                    reportId="883150ef-52f7-4b60-9d9c-7886052d1a56"
                    workspaceId="c9679fac-e043-4b12-b47b-d350f81543c1"
                    filterString={filterString}
                />
            </div>
        </FairValueChartsViewContainer>
    );
}
